import HMapLabel from './HMapLabel'
import { makeStyles } from '@material-ui/core'

const HMapTextField = ({
  width,
  name,
  value,
  onChange,
  placeholder,
  disabled,
  readonly
}) => {
  const classes = useStyles({ width })
  const textFieldProps = {
    ...({ type: 'text' }),
    ...({ className: classes.textField }),
    ...(name && { name }),
    ...(placeholder && { placeholder }),
    ...(disabled && { disabled }),
    ...(value && { value }),
    ...(onChange && { onChange })
  }

  const labelProps = {
    ...({ className: classes.lablelField }),
    ...({ width: `${width ? width : '100%'}` }),
    ...(value && { text: value }),
    ...({ fontType: 'p' }),
  }

  return !!readonly ? (
    <HMapLabel {...labelProps} />
  ) : (
    <input {...textFieldProps} />
  )
}

export default HMapTextField

const useStyles = makeStyles((theme, props) => ({
  textField: {
    width: (props) => (props.width ? props.width : '100%'),
    height: '25px',
    padding: '1px 5px',
    borderRadius: '5px',
    border: `1px solid ${theme.palette.tertiary.accent}`,
    color: theme.palette.primary.main,
    ...theme.typography.p,
    '&:focus': {
      outline: 'none'
    }
  },
  lablelField: {}
}))
